import React, { useContext } from "react";
import { ThemeContext } from "styled-components";
import {
  SpaceProps,
  LayoutProps,
  PositionProps,
  DisplayProps,
} from "styled-system";
import { Box } from "@bca/ui-library";

export interface StyledIconProps
  extends SpaceProps,
    LayoutProps,
    PositionProps,
    DisplayProps {
  fill?: string;
}

const TrashRegularSVG: React.FunctionComponent<StyledIconProps> = ({
  fill = "primary-light-blue",
  ...props
}) => {
  const theme = useContext(ThemeContext);
  const color = theme.colors[fill] || fill;

  return (
    <Box {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        focusable="false"
        viewBox="0 0 512 512"
        fill={color}
        height="100%"
        width="100%"
      >
        <path d="M432 80h-82.4l-34-56.7A48 48 0 0 0 274.4 0H173.6a48 48 0 0 0-41.2 23.3L98.4 80H16A16 16 0 0 0 0 96v16a16 16 0 0 0 16 16h16l21.2 339a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128h16a16 16 0 0 0 16-16V96a16 16 0 0 0-16-16zM173.6 48h100.8l19.2 32H154.4zm173.3 416H101.11l-21-336h287.8z" />
      </svg>
    </Box>
  );
};

export default TrashRegularSVG;
